var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"no-gutters":""}},_vm._l((_vm.gifs),function(gif){return _c('b-col',{key:gif.id,staticClass:"d-flex align-items-center my-2 p-2",attrs:{"cols":"6"}},[_c('img',{staticClass:"img-fluid rounded",attrs:{"src":gif.images.fixed_width.url},on:{"click":function($event){return _vm.$emit('selectedGif', gif)}}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }